import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "../../UI/loader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel, toBool } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { DayPicker } from "react-day-picker";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { popupOpenClose } from "../../../action/action";

const SpaBooking3b = (props) => {
  const { t } = props;

  const [therapistPreferenceData, setTherapistPreferenceData] = useState([
    { key: "NO_PREFERENCE", value: "No Preference" },
    { key: "MALE", value: "Male" },
    { key: "FEMALE", value: "Female" },
  ]);
  const [therapistPreference, setTherapistPreference] =
    useState("NO_PREFERENCE");

  // below code is for rendering date:
  let dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;
  const [renderDateInput, setRenderDateInput] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [inputDateFormat, setInputDateFormat] = useState("");

  const handlePreCheckInSelectedDate = (selectedDate) => {
    if (!selectedDate) {
      setSelectedDate("");
      setInputDateFormat("");
    } else {
      // converting to local date string
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
      const day = String(selectedDate.getDate()).padStart(2, "0");

      const localDateString = `${year}-${month}-${day}`;
      setSelectedDate(localDateString);
      setInputDateFormat(
        dateFormatHandler(
          new Date(localDateString).toISOString(),
          props.dateFormat
        )
      );

      setRenderDateInput(false);
    }
  };

  // below code is for start time
  const selectItemsRef = React.useRef(null);
  const [eta, setETA] = React.useState("");
  const [etaTimeList, setETATimeList] = React.useState([]);
  const [customETASelect, setCustomETASelect] = React.useState(false);

  const formatEstimateCheckInTime = (time, timeFormat12hrs) => {
    if (!time) {
      return "";
    }

    const [hours, minutes] = time.split(":");

    if (timeFormat12hrs) {
      let period = "AM";
      let hour = parseInt(hours, 10);

      if (hour >= 12) {
        period = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      return `${hour}:${minutes} ${period}`;
    } else {
      return `${hours}:${minutes}`;
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 30) {
        const hourString = String(hours).padStart(2, "0");
        const minuteString = String(minutes).padStart(2, "0");
        const timeValue = `${hourString}:${minuteString}`;
        const formatedTimeValue = timeValue;
        options.push(formatedTimeValue);
      }
    }
    setETATimeList(options);
  };

  const handleETAScroll = () => {
    if (selectItemsRef.current) {
      const itemHeight = 45;
      const selectedItemIndex = etaTimeList.indexOf(eta);
      selectItemsRef.current.scrollTop = selectedItemIndex * itemHeight;
    }
  };

  React.useEffect(() => {
    if (customETASelect) handleETAScroll();
  }, [customETASelect]);

  // end

  const handleBack = () => {
    props.goBack();
  };

  const handleNext = () => {
    if (selectedDate == "") {
      props.popupOpenClose(true, t("spaBooking.select_preferred_date"));
      return;
    }

    let serviceDetailsPayload;

    if (eta) {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}T${eta}:00`,
        requestedType: therapistPreference,
      };
    } else {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}`,
        requestedType: therapistPreference,
      };
    }

    props.next(serviceDetailsPayload);
  };

  useEffect(() => {
    generateTimeOptions();
  }, []);

  return (
    <section class="widgets spa-listing spa-details">
      <div class="widget-header">
        {props.currentWidgetObj.widgetHeaderImageUrl && (
          <div class="widget-header-img">
            <img
              src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
              alt={props.currentWidgetObj.displayName}
            />
          </div>
        )}
        <div class="widget-header-title">{t(`spaBooking.heading3b`)}</div>
      </div>

      <div class="widgets">
        <div class="row margin-bottom-2">
          <div class="row">
            <div class="col">
              <div class="detail-body stay-body">
                <form>
                  <div class="form-row">
                    <p class="heading">
                      {t("spaBooking.preferred_date")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="button"
                      value={
                        props.dateFormat && props.dateFormat != null
                          ? inputDateFormat ||
                            t("spaBooking.select_date_placeholder")
                          : selectedDate ||
                            t("spaBooking.select_date_placeholder")
                      }
                      onClick={() => setRenderDateInput(!renderDateInput)}
                    />
                  </div>

                  <div class="form-row">
                    <p class="heading">{t("spaBooking.preferred_time")}</p>

                    <div class={`custom-select`}>
                      <div
                        className="select-selected"
                        onClick={() => setCustomETASelect(!customETASelect)}
                      >
                        {eta
                          ? formatEstimateCheckInTime(
                              eta,
                              toBool(props.timeFormat)
                            )
                          : t("spaBooking.select_time_placeholder")}
                      </div>
                      <div className="select-items" ref={selectItemsRef}>
                        {customETASelect &&
                          etaTimeList.map((time, index) => {
                            return (
                              <div
                                onClick={(e) => {
                                  setETA(time);
                                  setCustomETASelect(!customETASelect);
                                }}
                                key={index}
                              >
                                {" "}
                                {formatEstimateCheckInTime(
                                  time,
                                  toBool(props.timeFormat)
                                )}{" "}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <p class="heading">{t("spaBooking.therapist")}</p>
                    <div class="form-options">
                      {therapistPreferenceData.map((option) => (
                        <label key={option.key}>
                          <input
                            type="radio"
                            name="therapist"
                            value={option.key}
                            checked={therapistPreference === option.key}
                            onChange={() => setTherapistPreference(option.key)}
                          />
                          {option.value}
                        </label>
                      ))}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-controls">
              <button onClick={handleNext}>{t("spaBooking.next")}</button>
              <button onClick={handleBack}>{t("spaBooking.back")}</button>
            </div>
          </div>
        </div>
      </div>

      {renderDateInput && (
        <div
          className="overlay"
          onClick={() => setRenderDateInput(!renderDateInput)}
        >
          <div
            onClick={(event) => {
              event.stopPropagation();
            }}
            class="overlay-date"
          >
            <style>{dateInputCss}</style>
            <DayPicker
              mode="single"
              selected={new Date(selectedDate)}
              onSelect={(selectedDate) =>
                handlePreCheckInSelectedDate(selectedDate)
              }
              disabled={
                {
                  // before: new Date(props.serverTimeDate.split("T")[0])
                }
              }
            />
          </div>
        </div>
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    timeFormat:
      state.store.home.clientConfig.extraConfigParam &&
      state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    serverTimeDate: state.store.home.serverTimeDate.date,
    menuColor: state.store.home.MenuColor,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
  };
};

export default connect(mapStateToProps, {
  closeOrderPopUp,
  sendAnalytics,
  popupOpenClose,
})(withTranslation("translations")(SpaBooking3b));
